import React from "react";

export const TourneyTileSkeleton = () => (
  <div className="rounded-300 flex-1 mt-3 relative bg-gradient-to-r from-card-grad-1 from-0% to-card-grad-2 border border-b-main animate-pulse mx-4">
    <div className="p-4">
      {/* Tournament Name and Image Placeholder */}
      <div className="flex justify-between items-center mb-4">
        <div className="h-4 w-1/2 bg-h-secondary rounded"></div>
      </div>

      {/* Prize Pool and Player Count Placeholder */}
      <div className="flex justify-between items-end mb-4">
        <div>
          <div className="h-6 w-32 bg-h-secondary rounded mb-2"></div>
          <div className="h-4 w-20 bg-h-secondary rounded"></div>
        </div>

        {/* CTA Placeholder */}
        <div className="h-5 w-24 bg-h-secondary rounded-400"></div>
      </div>

      {/* Game Type and Timer Placeholder */}
      <div className="flex justify-between items-center">
        <div className="flex gap-1.5">
          <div className="h-6 w-12 bg-h-secondary rounded"></div>
          <div className="h-6 w-12 bg-h-secondary rounded"></div>
          <div className="h-6 w-12 bg-h-secondary rounded"></div>
        </div>
        <div className="h-4 w-24 bg-h-secondary rounded"></div>
      </div>
    </div>
  </div>
);
